import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import Navigation from '../../components/Navigation/Navigation';
import GoogleSignInButton from '../../components/GoogleSignInButton/GoogleSignInButton';
import './LoginPage.css';

const LoginPage: React.FC = () => {
  const [errors, setErrors] = useState<Record<string, string>>({});
  const [isLoading, setIsLoading] = useState(false);

  const { loginWithGoogle } = useAuth();
  const navigate = useNavigate();

  const handleGoogleSuccess = async (credentialResponse: any) => {
    try {
      setIsLoading(true);
      const idToken = credentialResponse.credential;
      await loginWithGoogle(idToken);
      navigate('/dashboard');
    } catch (error) {
      console.error('Google login failed:', error);
      setErrors({
        general: 'Google sign-in failed. Please try again.',
      });
    } finally {
      setIsLoading(false);
    }
  };

  const handleGoogleError = () => {
    console.error('Google sign-in was unsuccessful');
    setErrors({
      general: 'Google sign-in was unsuccessful. Please try again.',
    });
  };

  return (
    <div className="login-page">
      <Navigation showBack={false} showHome={false} />
      <div className="login-container">
        <div className="login-card">
          <div className="login-header">
            <h1 className="login-title">Welcome Back</h1>
            <p className="login-subtitle">Sign in with Google to continue</p>
          </div>

          <div className="login-form">
            {errors.general && (
              <div className="error-message">
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                >
                  <circle cx="12" cy="12" r="10" />
                  <line x1="15" y1="9" x2="9" y2="15" />
                  <line x1="9" y1="9" x2="15" y2="15" />
                </svg>
                {errors.general}
              </div>
            )}

            <GoogleSignInButton
              onSuccess={handleGoogleSuccess}
              onError={handleGoogleError}
              disabled={isLoading}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
